import { IGetFornecedorDropDownUseCase } from "../../../presentation/useCases/read/get_fornecedor_drop_down_use_case";
import { FornecedorDropDown } from "../../models/fornecedor_dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetFornecedorDropDownUseCase
 */

export class GetFornecedorDropDownUseCase implements IGetFornecedorDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getFornecedorDropDown(
    filtrarCentroCusto?: boolean,
    FornServico?: boolean
  ): Promise<FornecedorDropDown[]> {
    return await this.repository.getFornecedorDropDown(filtrarCentroCusto ?? false, FornServico ?? false);
  }
}
